// Must stay the first import - see polyfills.js
import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AppErrorBoundary from './components/AppErrorBoundary';
import reportWebVitals from './reportWebVitals';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

// Non-live builds (REACT_APP_ENV_LABEL, set in .env.staging) get a fixed
// corner badge and a tab-title prefix, so a staging tab can never be
// mistaken for the live site. Plain DOM, outside React, so it shows on
// every screen including login. Unset on live builds — nothing rendered.
if (process.env.REACT_APP_ENV_LABEL) {
  const label = process.env.REACT_APP_ENV_LABEL;
  const badge = document.createElement('div');
  badge.textContent = label;
  badge.setAttribute('style', 'position:fixed;bottom:10px;left:10px;z-index:2147483647;background:#d97706;color:#fff;font:700 12px/1 system-ui,sans-serif;letter-spacing:0.08em;padding:6px 10px;border-radius:6px;pointer-events:none;box-shadow:0 2px 6px rgba(0,0,0,0.25)');
  document.body.appendChild(badge);
  document.title = `[${label}] ${document.title}`;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();